import { __spreadArray } from "tslib";
import { LogLevel } from './logger.interfaces';
var SimpleLogger = /** @class */ (function () {
    function SimpleLogger() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.instanceTags = [];
        this.instanceTags = args;
    }
    Object.defineProperty(SimpleLogger.prototype, "consoleLevel", {
        get: function () {
            return SimpleLogger.commonConsoleLevel;
        },
        set: function (level) {
            SimpleLogger.commonConsoleLevel = level;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SimpleLogger.prototype, "serverLevel", {
        get: function () {
            return SimpleLogger.commonServerLevel;
        },
        set: function (level) {
            SimpleLogger.commonServerLevel = level;
        },
        enumerable: false,
        configurable: true
    });
    SimpleLogger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.log(LogLevel.error, args);
    };
    SimpleLogger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.log(LogLevel.warn, args);
    };
    SimpleLogger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.log(LogLevel.info, args);
    };
    SimpleLogger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.log(LogLevel.debug, args);
    };
    SimpleLogger.prototype.trace = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.log(LogLevel.trace, args);
    };
    SimpleLogger.prototype.child = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new (SimpleLogger.bind.apply(SimpleLogger, __spreadArray(__spreadArray([void 0], this.instanceTags, false), args, false)))();
    };
    SimpleLogger.prototype.log = function (level, args) {
        if (this.consoleLevel >= level) {
            this.sendLogToConsole.apply(this, __spreadArray([level], this.instanceTags.concat(args), false));
        }
        if (this.serverLevel >= level) {
            this.sendLogToServer.apply(this, __spreadArray([level], this.instanceTags.concat(args), false));
        }
    };
    SimpleLogger.prototype.sendLogToConsole = function (level) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var consoleFunctionName = LogLevel[level];
        // To prevent failure on old browsers
        if (console[consoleFunctionName]) {
            console[consoleFunctionName].apply(console, args);
        }
        else {
            console.log.apply(console, args);
        }
    };
    SimpleLogger.prototype.sendLogToServer = function (level) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        console.log.apply(console, __spreadArray([LogLevel[level], 'sending to server...'], args, false));
    };
    SimpleLogger.commonConsoleLevel = LogLevel.warn;
    SimpleLogger.commonServerLevel = LogLevel.error;
    return SimpleLogger;
}());
export { SimpleLogger };
//# sourceMappingURL=simple-logger.js.map